import { motion } from "framer-motion";
import { ShieldCheck, HeartHandshake, Home, Users } from "lucide-react";

const pillars = [
  { icon: ShieldCheck, title: "Water safety first", text: "Every lesson is built around safety skills before strokes.", id: "trust-card-safety" },
  { icon: HeartHandshake, title: "Warm, patient teachers", text: "Caring instructors who meet every child at their own pace.", id: "trust-card-teachers" },
  { icon: Home, title: "On-property convenience", text: "Lessons at your own pool — your commute is an elevator ride.", id: "trust-card-convenience" },
  { icon: Users, title: "Small groups, ages 1–12", text: "Tiny class sizes so every swimmer gets real attention.", id: "trust-card-groups" },
];

export default function Trust() {
  return (
    <section data-testid="trust-section" className="bg-[#00334a] text-[#f8f3e9]">
      <div className="mx-auto max-w-6xl px-4 sm:px-8 py-16 sm:py-24">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="font-serif text-2xl sm:text-3xl lg:text-4xl font-bold max-w-2xl"
        >
          Why Four Seasons parents trust Little Splash
        </motion.h2>
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {pillars.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={p.id}
              className="rounded-3xl bg-white/[0.06] border border-white/10 p-6 backdrop-blur-sm hover:bg-white/[0.1] transition-colors duration-300"
            >
              <p.icon className="h-8 w-8 text-[#e7b576]" />
              <h3 className="mt-4 font-serif text-xl font-semibold">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#f8f3e9]/70">{p.text}</p>
            </motion.div>
          ))}
        </div>
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: 0.15 }}
          data-testid="director-promise"
          className="mt-14 grid items-center gap-8 rounded-3xl bg-white/[0.06] border border-white/10 p-6 sm:p-10 md:grid-cols-[220px_1fr]"
        >
          <img
            src="/photos/IMG_9515.jpeg"
            alt="Coach Abrie gently guiding a young swimmer with a kickboard"
            loading="lazy"
            className="h-56 w-full md:h-64 rounded-2xl object-cover shadow-lg"
          />
          <div>
            <p className="font-serif text-xl sm:text-2xl lg:text-3xl italic leading-snug text-[#f8f3e9]">
              "Book a free trial and watch your child light up in the water — then decide.
              No pressure, no obligation. That's my promise to every Four Seasons family."
            </p>
            <p className="mt-5 text-sm font-semibold tracking-wide text-[#e7b576] uppercase">
              Coach Abrie · Program Director, Little Splash Swim Program
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
